module.exports = __webpack_public_path__ + "img/Urban_Solar_120X35.70302e9a.png";